import React from 'react';
import PropTypes from 'prop-types';

import InventoryTagItemSpan from '../InventoryTagItemSpan';


const propTypes = {
  tagIconName: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  iconClass: PropTypes.string.isRequired,
  gray: PropTypes.bool
};

const defaultProps = {
  gray: false
};

export default class BaseInventoryTagSpan extends React.Component {
  render() {
    return (
      <InventoryTagItemSpan
        name={this.props.name}
        icon={this.props.tagIconName}
        iconClass={this.props.iconClass}
        gray={this.props.gray}
        key={this.props.name} />
    );
  }
}

BaseInventoryTagSpan.propTypes = propTypes;
BaseInventoryTagSpan.defaultProps = defaultProps;
